import lscache from 'lscache';

const PLP_LSCACHE_TTL_MINUTES = 30;

/**
 * Store JSON-serializable PLP data with expiration (localStorage + TTL).
 */
export function plpLscacheSet<T>(key: string, value: T): void {
  try {
    lscache.set(key, value, PLP_LSCACHE_TTL_MINUTES);
  } catch {
    // quota / private mode
  }
}

export function plpLscacheGet<T>(key: string): T | null {
  try {
    const hit = lscache.get(key);
    if (hit !== null) return hit as T;
  } catch {
    // ignore
  }
  return null;
}

export function plpLscacheRemove(key: string): void {
  try {
    lscache.remove(key);
  } catch {
    // ignore
  }
}
